import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import MemberLayout from "./MemberLayout";
import InvestorLayout from "./InvestorLayout";
import { useUserType } from "../hooks";
import { canAccessMemberModule, isInvestorPath } from "../utils/investorAccess";
import InvestorPortalCapabilityGate from "../components/Investor/InvestorPortalCapabilityGate";
import StaffRoleRoute from "../components/Common/StaffRoleRoute";
import TawkTo from "../components/Common/TawkTo";
import IdleSessionWatcher from "../components/Common/IdleSessionWatcher";

function Dashboard() {
  const userType = useUserType();
  const { pathname } = useLocation();

  const isMember = React.useMemo(
    () => canAccessMemberModule(userType),
    [userType]
  );

  const onInvestorModulePath = React.useMemo(() => isInvestorPath(pathname), [pathname]);

  // Cooperative members keep the member portal shell on /invest/* — one unified experience.
  const useInvestorLayout = React.useMemo(() => {
    if (!onInvestorModulePath) return false;
    if (isMember) return false;
    return true;
  }, [onInvestorModulePath, isMember]);

  if (useInvestorLayout) {
    return (
      <>
        <InvestorLayout>
          <Outlet />
        </InvestorLayout>
        <IdleSessionWatcher />
        <TawkTo />
      </>
    );
  }

  return (
    <>
      {isMember ? (
        <MemberLayout>
          {onInvestorModulePath ? (
            <InvestorPortalCapabilityGate>
              <Outlet />
            </InvestorPortalCapabilityGate>
          ) : (
            <Outlet />
          )}
        </MemberLayout>
      ) : (
        <AdminLayout>
          <StaffRoleRoute>
            <Outlet />
          </StaffRoleRoute>
        </AdminLayout>
      )}
      <IdleSessionWatcher />
      <TawkTo />
    </>
  );
}

export default Dashboard;
